export class ActionRequiredDetails {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "actionRequiredType",
            "baseName": "actionRequiredType",
            "type": "ActionRequiredType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ActionRequiredDetails.attributeTypeMap;
    }
    constructor() {
    }
}
